import { render } from "./Notificatiions.vue?vue&type=template&id=6cec45f4"
import script from "./Notificatiions.vue?vue&type=script&lang=js"
export * from "./Notificatiions.vue?vue&type=script&lang=js"

import "./Notificatiions.vue?vue&type=style&index=0&id=6cec45f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__